/* MyGiftZone: na kartach produktów (strona główna, kolekcje, wyszukiwarka) kubek ze zdjęciem
   pokazuje okienko „Tu będzie Twoje zdjęcie” – to samo co na stronie produktu i na poduszce. */
(function () {
  var PH = {
    // uchwyt produktu: środek x, środek y, szerokość, wysokość (ułamki zdjęcia) – jak w szablonie kubek-zdjecie
    'kubek-bialy-330-ml-z-twoim-zdjeciem': [0.37, 0.51, 0.44, 0.46],
    'koszulka-biala-z-twoim-zdjeciem': [0.50, 0.48, 0.30, 0.34],
    'bidon-aluminiowy-500-ml-z-twoim-zdjeciem': [0.50, 0.63, 0.22, 0.40],
    'mis-pluszowy-z-twoim-zdjeciem': [0.53, 0.55, 0.22, 0.11],
    'poduszka-z-twoim-zdjeciem': [0.50, 0.48, 0.56, 0.56]
  };
  // „Tu będzie Twoje zdjęcie” bez szarego tła – sama ikona aparatu i napis (karty i strona produktu)
  var css = '.mgz-card-ph{position:absolute;z-index:1;transform:translate(-50%,-50%);display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4%;color:#5c5c63;text-align:center;font-weight:600;line-height:1.2;font-size:11px;pointer-events:none;container-type:size}' +
    '.mgz-card-ph svg{width:24cqw;height:auto;max-height:34cqh}.mgz-card-ph span{font-size:clamp(9px,9cqw,18px)}' +
    '.mug-foto-overlay.is-empty .mug-foto-ph{background:transparent;border-radius:0}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
  var ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M4 8h3l1.6-2.2h6.8L17 8h3a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1z"/><circle cx="12" cy="13.2" r="3.6"/></svg>';

  function handleOf(el) {
    var a = el.querySelector('a[href*="/products/"]') || el.closest('a[href*="/products/"]');
    var m = a && a.getAttribute('href').match(/\/products\/([^\/?#]+)/);
    return m && m[1];
  }
  function decorate() {
    document.querySelectorAll('.card-gallery:not([data-mgz-ph]), .product-card:not([data-mgz-ph])').forEach(function (g) {
      g.setAttribute('data-mgz-ph', '');
      var box = PH[handleOf(g)];
      if (!box) return;
      var c = g.querySelector('.product-media-container');
      if (!c || c.querySelector('.mgz-card-ph')) return;
      if (getComputedStyle(c).position === 'static') c.style.position = 'relative';
      var d = document.createElement('div');
      d.className = 'mgz-card-ph';
      d.style.left = box[0] * 100 + '%';
      d.style.top = box[1] * 100 + '%';
      d.style.width = box[2] * 100 + '%';
      d.style.height = box[3] * 100 + '%';
      d.innerHTML = ICON + '<span>Tu będzie<br>Twoje zdjęcie</span>';
      c.appendChild(d);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', decorate);
  else decorate();
  var t = null;
  new MutationObserver(function () {
    if (t) return;
    t = setTimeout(function () { t = null; decorate(); }, 120);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* MyGiftZone: pod przyciskami „Dodaj do koszyka / Kup teraz” na stronie produktu – rozwijane informacje
   (pakowanie, płatności, darmowa dostawa). Treść zmieniasz tutaj. */
(function () {
  var ITEMS = [
    ['bolt', 'Zamówienia do 14:00 wysyłamy tego samego dnia',
      'Każde zamówienie wykonujemy ręcznie. Zamówienia opłacone w dni robocze do 14:00 wysyłamy tego samego dnia, późniejsze – następnego dnia roboczego. Przewoźnik doręcza zwykle w 1–2 dni.'],
    ['gift', 'Zestawy taniej – do −15%',
      'Kup razem i zaoszczędź: do kubka koszulka 15% taniej, do kubka poduszka 10% taniej, a przy 3 kubkach i więcej – 15% taniej na kubki. Rabat nalicza się automatycznie w koszyku.'],
    ['box', 'Bezpieczne pakowanie do transportu',
      'Każde zamówienie zabezpieczamy folią bąbelkową i wysyłamy w grubych, wytrzymałych kartonach. Dzięki temu Twój prezent dociera do Ciebie w nienaruszonym stanie, bez ryzyka uszkodzenia w transporcie.'],
    ['card', 'Wygodne płatności: BLIK, karta, Apple Pay, Google Pay',
      'Zapłać tak, jak Ci wygodnie: BLIK-iem, kartą, Apple Pay albo Google Pay. Wszystkie płatności są bezpieczne i szyfrowane, a obsługuje je Shopify Payments.'],
    ['truck', 'Darmowa dostawa od 150 zł',
      'Przy zamówieniach od 150 zł dostawa jest całkowicie darmowa.']
  ];
  // kubki: na pierwszym miejscu informacja o zmywarce
  if (/\/products\/kubek/.test(location.pathname)) {
    ITEMS.unshift(['dish', 'Nadruk odporny na zmywarkę',
      'Nadruk jest trwały i odporny na mycie w zmywarce, więc kubek możesz używać na co dzień bez obaw o wygląd nadruku.']);
  }
  var ICONS = {
    dish: '<path d="M12 3s-5 5.6-5 9.2A5 5 0 0 0 12 17a5 5 0 0 0 5-4.8C17 8.6 12 3 12 3Z"/><path d="M4 20h16M19 4l.6 1.4L21 6l-1.4.6L19 8l-.6-1.4L17 6l1.4-.6Z"/>',
    box: '<path d="M12 3 3.5 7.5v9L12 21l8.5-4.5v-9L12 3Z"/><path d="M3.5 7.5 12 12l8.5-4.5M12 12v9"/>',
    card: '<rect x="2.5" y="5" width="19" height="14" rx="2.5"/><path d="M2.5 10h19M6 15h4"/>',
    bolt: '<path d="M13 2 4.5 13.5H11L10 22l8.5-11.5H12L13 2Z"/>',
    gift: '<rect x="3" y="8" width="18" height="4" rx="1"/><path d="M12 8v13M5 12v8a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-8M12 8S10.5 3 8 3.6 7.4 8 12 8Zm0 0s1.5-5 4-4.4S16.6 8 12 8Z"/>',
    truck: '<path d="M2.5 6.5h11v9h-11z"/><path d="M13.5 9.5h4l3 3v3h-7"/><circle cx="6.5" cy="17" r="1.8"/><circle cx="17" cy="17" r="1.8"/>'
  };
  var css = '.mgz-info{margin-top:8px;border-top:1px solid rgb(0 0 0 / .1)}' +
    '.mgz-info details{border-bottom:1px solid rgb(0 0 0 / .1)}' +
    '.mgz-info summary{display:flex;align-items:center;gap:14px;padding:16px 2px;cursor:pointer;list-style:none;font-size:1rem;line-height:1.35}' +
    '.mgz-info summary::-webkit-details-marker{display:none}' +
    '.mgz-info summary svg.i{flex:none;width:22px;height:22px}' +
    '.mgz-info summary span{flex:1}' +
    '.mgz-info summary svg.ch{flex:none;width:16px;height:16px;opacity:.55;transition:transform .25s ease}' +
    '.mgz-info details[open] summary svg.ch{transform:rotate(180deg)}' +
    '.mgz-info p{margin:0;padding:0 2px 18px 38px;font-size:.9375rem;line-height:1.6;opacity:.75}' +
    '@media (prefers-reduced-motion:no-preference){.mgz-info details[open] p{animation:mgz-info-in .25s ease}}' +
    '@keyframes mgz-info-in{from{opacity:0;transform:translateY(-4px)}to{opacity:.75;transform:none}}';
  function svg(cls, body, sw) {
    return '<svg class="' + cls + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + sw + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + body + '</svg>';
  }
  function build() {
    if (!/\/products\//.test(location.pathname) || document.querySelector('.mgz-info')) return true;
    var forms = document.querySelectorAll('form[id^="BuyButtons-ProductForm-"]');
    var f = null;
    for (var i = 0; i < forms.length; i++) if (!forms[i].closest('dialog, quick-add-component, product-card')) { f = forms[i]; break; }
    if (!f) return false;
    var anchor = f.closest('.buy-buttons-block, [class*="buy-buttons"]') || f;
    var box = document.createElement('div');
    box.className = 'mgz-info';
    box.innerHTML = ITEMS.map(function (it) {
      return '<details><summary>' + svg('i', ICONS[it[0]], 1.5) + '<span>' + it[1] + '</span>' +
        svg('ch', '<path d="M6 9l6 6 6-6"/>', 2) + '</summary><p>' + it[2] + '</p></details>';
    }).join('');
    anchor.insertAdjacentElement('afterend', box);
    return true;
  }
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
  var tries = 0;
  (function run() { if (!build() && tries++ < 40) setTimeout(run, 150); })();
})();

/* MyGiftZone: przycisk „Wybierz” / szybkie dodanie na kartach produktów prowadzi na stronę produktu.
   Wszystkie produkty są personalizowane (imię, zdjęcie), a okienko szybkiego zakupu nie ma tych pól. */
(function () {
  window.addEventListener('click', function (e) {
    var q = e.target && e.target.closest && e.target.closest('quick-add-component');
    if (!q || !e.target.closest('button, a')) return;
    var card = q.closest('product-card');
    var url = q.productPageUrl || (card && card.productPageUrl);
    if (!url) {
      var a = (card || q.parentElement).querySelector('a[href*="/products/"]');
      url = a && a.href;
    }
    if (!url) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    window.location.href = url;
  }, true);
})();

/* MyGiftZone: „Dodaj czerwoną wstążkę ozdobną” na stronie produktu. Zaznaczona wstążka trafia do koszyka
   razem z produktem (osobna pozycja, z informacją, do którego produktu). ID wariantu wstążki: RIBBON_ID. */
(function () {
  var RIBBON_ID = 55550773821777;
  var RIBBON_PRICE = '5 zł';
  if (!RIBBON_ID || !/\/products\//.test(location.pathname) || /\/products\/wstazka/.test(location.pathname)) return;
  var css = '.mgz-ribbon{display:flex;align-items:center;gap:12px;padding:12px 14px;margin:2px 0 6px;border:1.5px solid rgb(0 0 0 / .12);border-radius:14px;cursor:pointer;transition:border-color .15s,background-color .15s;user-select:none}' +
    '.mgz-ribbon:hover{border-color:#C9505A}.mgz-ribbon.is-on{border-color:#C9505A;background:#FBEDEE}' +
    '.mgz-ribbon input{width:20px;height:20px;accent-color:#C9505A;flex:none;margin:0}' +
    '.mgz-ribbon__ic{flex:none;width:34px;height:34px}.mgz-ribbon__t{flex:1;line-height:1.3}.mgz-ribbon__t b{display:block;font-size:.95rem}.mgz-ribbon__t small{opacity:.7;font-size:.8125rem}' +
    '.mgz-ribbon__p{font-weight:700;color:#B23E47;white-space:nowrap}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);
  var BOW = '<svg class="mgz-ribbon__ic" viewBox="0 0 48 48" aria-hidden="true"><path fill="#D8202E" d="M24 22c-6-9-17-11-18-5-1 5 9 9 18 5Zm0 0c6-9 17-11 18-5 1 5-9 9-18 5Z"/><path fill="#B3151F" d="M22 23 15 40l5-1 3 4 3-19Zm4 0 7 17-5-1-3 4-3-19Z"/><rect x="20" y="19" width="8" height="8" rx="2.5" fill="#E8333F"/></svg>';
  var box = null, title = '';
  function build() {
    if (document.querySelector('.mgz-ribbon')) return true;
    var forms = document.querySelectorAll('form[id^="BuyButtons-ProductForm-"]');
    var f = null;
    for (var i = 0; i < forms.length; i++) if (!forms[i].closest('dialog, quick-add-component, product-card')) { f = forms[i]; break; }
    if (!f) return false;
    var h = document.querySelector('h1');
    title = h ? h.textContent.trim() : '';
    box = document.createElement('label');
    box.className = 'mgz-ribbon';
    box.innerHTML = '<input type="checkbox">' + BOW + '<span class="mgz-ribbon__t"><b>Dodaj czerwoną wstążkę ozdobną</b><small>Gotowe do wręczenia – zawiążemy ją na prezencie</small></span><span class="mgz-ribbon__p">+' + RIBBON_PRICE + '</span>';
    var cb = box.querySelector('input');
    cb.addEventListener('change', function () { box.classList.toggle('is-on', cb.checked); });
    var block = f.closest('.buy-buttons-block, [class*="buy-buttons"]') || f;
    block.insertAdjacentElement('beforebegin', box);
    return true;
  }
  var tries = 0;
  (function run() { if (!build() && tries++ < 40) setTimeout(run, 150); })();

  // wstążka dodaje się tuż PRZED produktem – odpowiedź koszyka (szuflada, licznik) od razu ją zawiera
  var origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = (typeof input === 'string' ? input : (input && input.url)) || '';
    var cb = box && box.querySelector('input');
    var isAdd = /\/cart\/add/.test(url) && !(init && init.mgzRibbon);
    if (!isAdd || !cb || !cb.checked) return origFetch.apply(this, arguments);
    var self = this, args = arguments;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    var body = JSON.stringify({ items: [{ id: RIBBON_ID, quantity: 1, properties: { 'Do produktu': title } }] });
    return origFetch.call(window, root + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body, mgzRibbon: true })
      .catch(function () {})
      .then(function () { return origFetch.apply(self, args); });
  };
})();

/* MyGiftZone: zamiast przycisku Shopify „Kup, używając G Pay” / „Więcej opcji płatności” – jeden przycisk
   „Kup teraz” (BLIK, Apple Pay, Google Pay). Działa jak „Dodaj do koszyka” (sprawdza imię/zdjęcie, dołącza
   podgląd projektu), a po dodaniu od razu przechodzi do kasy – do ekranu dostawy. Płatność wybiera się w kasie. */
(function () {
  if (!/\/products\//.test(location.pathname)) return;
  var css = '.mgz-hide-acc shopify-accelerated-checkout,.mgz-hide-acc .shopify-payment-button,.mgz-hide-acc [class*="accelerated-checkout"],.mgz-hide-acc [class*="more-payment"]{display:none!important}' +
    '.mgz-buynow{display:flex;flex-direction:column;align-items:center;justify-content:center;gap:6px;width:100%;min-height:58px;margin-top:10px;padding:10px 16px;border:0;border-radius:var(--style-border-radius-buttons-primary,14px);background:#111;color:#fff;font:inherit;cursor:pointer;transition:background-color .2s,transform .12s}' +
    '.product-form-buttons .mgz-buynow{grid-column:1/-1;margin-top:0}.mgz-buynow:hover{background:#2a2a2a}.mgz-buynow:active{transform:scale(.98)}.mgz-buynow[aria-busy=true]{opacity:.7;cursor:progress}' +
    '.mgz-buynow__t{font-size:1rem;font-weight:700;letter-spacing:.01em}' +
    '.mgz-buynow__p{display:flex;gap:6px;flex-wrap:wrap;justify-content:center}' +
    '.mgz-buynow__p span{padding:2px 9px;border:1px solid rgb(255 255 255 / .35);border-radius:6px;font-size:.75rem;font-weight:600;line-height:1.5;background:rgb(255 255 255 / .08)}' +
    '.mgz-buynow__p .mgz-pi{padding:0;border:0;background:none;display:flex}.mgz-buynow__p .mgz-pi svg{display:block;height:26px;width:auto}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  // po udanym dodaniu do koszyka (tylko po kliknięciu „Kup teraz”) – prosto do koszyka-formularza (dane, dostawa, płatność)
  var buyNow = 0, btn = null;
  function done() { buyNow = 0; if (btn) { btn.removeAttribute('aria-busy'); btn.querySelector('.mgz-buynow__t').textContent = 'Kup teraz'; } }
  var origFetch = window.fetch;
  window.fetch = function (input) {
    var p = origFetch.apply(this, arguments);
    var url = (typeof input === 'string' ? input : (input && input.url)) || '';
    if (buyNow && Date.now() - buyNow < 20000 && /\/cart\/add/.test(url)) {
      buyNow = 0;
      p.then(function (r) {
        if (r.ok) window.location.href = (window.Shopify && Shopify.routes && Shopify.routes.root || '/') + 'cart'; // koszyk = formularz zamówienia
        else done();
      }).catch(done);
    }
    return p;
  };

  function build() {
    if (document.querySelector('.mgz-buynow')) return true;
    var forms = document.querySelectorAll('form[id^="BuyButtons-ProductForm-"]');
    var f = null;
    for (var i = 0; i < forms.length; i++) if (!forms[i].closest('dialog, quick-add-component, product-card')) { f = forms[i]; break; }
    if (!f) return false;
    var id = f.getAttribute('id');
    var add = f.querySelector('button[type="submit"], button[name="add"]') ||
      document.querySelector('button[type="submit"][form="' + id + '"]');
    if (!add) return false;
    var block = f.closest('.buy-buttons-block, [class*="buy-buttons"]') || f;
    block.classList.add('mgz-hide-acc');
    btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'mgz-buynow';
    btn.innerHTML = '<span class="mgz-buynow__t">Kup teraz</span><span class="mgz-buynow__p" aria-hidden="true"><span data-k="blik">BLIK</span><span data-k="apple_pay">Apple Pay</span><span data-k="google_pay">Google Pay</span></span>';
    // oficjalne ikony płatności Shopify (theme.liquid → <template id="mgz-pay-icons">); bez nich zostaje napis
    var icons = document.getElementById('mgz-pay-icons');
    if (icons && icons.content) {
      btn.querySelectorAll('[data-k]').forEach(function (pill) {
        var src = icons.content.querySelector('[data-k="' + pill.getAttribute('data-k') + '"] svg');
        if (!src) return;
        pill.textContent = '';
        pill.className = 'mgz-pi';
        pill.appendChild(src.cloneNode(true));
      });
    }
    btn.setAttribute('aria-label', 'Kup teraz – BLIK, Apple Pay lub Google Pay');
    btn.addEventListener('click', function () {
      if (btn.getAttribute('aria-busy') === 'true') return;
      if (!f.reportValidity()) return;               // brak imienia / zdjęcia – przeglądarka pokaże, co uzupełnić
      buyNow = Date.now();
      btn.setAttribute('aria-busy', 'true');
      btn.querySelector('.mgz-buynow__t').textContent = 'Przechodzę do kasy…';
      add.click();
      setTimeout(function () { if (buyNow) done(); }, 20000);
    });
    // ostatni element w siatce przycisków (pod „ilość + Dodaj do koszyka”), w miejscu ukrytej szybkiej płatności Shopify
    var grid = f.querySelector('.product-form-buttons') || add.parentElement;
    grid.appendChild(btn);
    return true;
  }
  var tries = 0;
  (function run() { if (!build() && tries++ < 40) setTimeout(run, 150); })();
})();
